import { Route } from '@tanstack/react-router'
import { rootRoute } from '@ui/routing/RootRouteIndex'
import { CreateGreetingContainer } from '@ui/components/Greeting/Create/CreateGreetingContainer'

export const createGreetingRoute = new Route({
  getParentRoute: () => rootRoute,
  path: '/create', // add lng
  component: CreateGreetingContainer,
})
